var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabsSolid = function SvgTabsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M20 13.125a.625.625 0 0 1-.625.625H.625a.624.624 0 0 1-.596-.812L1.768 7.14a1.24 1.24 0 0 1 1.2-.891H9.54a1.24 1.24 0 0 1 1.197.89l1.608 5.36h1.195l-1.758-5.848a.313.313 0 0 1 .299-.402h1.205a1.25 1.25 0 0 1 1.197.89l1.612 5.36h1.195L15.53 6.652a.313.313 0 0 1 .3-.402h1.205a1.25 1.25 0 0 1 1.197.89l1.74 5.796q.027.092.028.189"
  })));
};
export default SvgTabsSolid;